import React, { useEffect, useState, useRef } from "react";
import * as commentService from "./../_redux/commentCrud";
import CommentItem from "./CommentItem";
import FeedbackItem from "./FeedbackItem";
import ClipLoader from "react-spinners/ClipLoader";
import ReplyComment from "./ReplyComment";
import { useSelector } from "react-redux";
import { setHeightLayout } from "./../helpers";
import { Trans } from "react-i18next";
import { LoadingIcon, ReturnIcon } from "./icons";
import queryString from 'query-string';

function CommentBox({
    dataComment,
    currentTab,
    lastIndex,
    lastIndexItem,
    currentIndex
}) {
    // ___REDUX
    const { currentState } = useSelector(state => ({
        currentState: state.comment
    }));
    const { commentSetting } = currentState;
    // __STATE
    const [totalReply, setTotalReply] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [isReply, setIsReply] = useState(false);

    // __EFFECT
    useEffect(() => {
        // console.log('running !');
        setHeightLayout(0);
    }, [totalReply, isReply]);

    // __FUNCTION HANDLE
    const onToggleReply = _boolean => {
        setIsReply(_boolean);
        setTimeout(() => {
            window.parent.postMessage(
                { clientHeight: document.body.offsetHeight + 10 },
                "*"
            );
        }, 10);
    };
    const onShowAllReplyComment = async () => {
        setShowLoading(true);
        const request = {
            SortType: currentTab,
            objectId: commentSetting.objectId,
            parentId: dataComment.commentId,
            pageIndex: 0,
            pageSize: 25
        };
        const locationParser = queryString.parse(window.location.search);
        if (locationParser?.commentId) request.commentId = locationParser.commentId;
        if (commentSetting?.sourceType)
            request.SourceType = commentSetting?.sourceType;
        try {
            const {
                data: { data }
            } = await commentService.gets(request);
            setTimeout(() => {
                setShowLoading(false);
                setTotalReply(data?.comments || []);
                setTimeout(() => {
                    window.parent.postMessage(
                        { clientHeight: document.body.offsetHeight + 10 },
                        "*"
                    );
                }, 10);
            }, 200);
        } catch (error) {
            console.log(error.message);
        }
    };
    // __RENDER
    return (
        <div className='mb-[10px] '>
            <CommentItem
                isReply={isReply}
                data={dataComment}
                onToggleReply={onToggleReply}
                lastIndexItem={lastIndexItem}
                currentIndex={currentIndex}
            />
            {/* feedback */}
            {isReply && (
                <div className='ml-[60px]'>
                    <ReplyComment
                        lastIndex={lastIndex}
                        type='replyParent'
                        parentData={dataComment}
                        setIsReply={setIsReply}
                    />
                </div>
            )}
            {/* feedback */}
            <ul className='ml-[60px] border-l border-[#E0E0E0]'>
                {dataComment?.comments?.map((item, key) => {
                    return (
                        <li key={key}>
                            <FeedbackItem
                                data={item}
                                totalReply={totalReply}
                                parentData={dataComment}
                                type='replyChilren'
                            />
                        </li>
                    );
                })}
                {// show all reply comment
                totalReply?.length > 0
                    ? totalReply.map((item, key) => {
                          if (key >= totalReply.length - 3) {
                              return (
                                  <li key={key}>
                                      <FeedbackItem
                                          lastIndex={lastIndex}
                                          data={item}
                                          totalReply={totalReply}
                                          parentData={dataComment}
                                          type='replyChilren'
                                      />
                                  </li>
                              );
                          }
                          return (
                              <li key={key}>
                                  <FeedbackItem
                                      data={item}
                                      totalReply={totalReply}
                                      parentData={dataComment}
                                      type='replyChilren'
                                  />
                              </li>
                          );
                      })
                    : null}
            </ul>
            {(dataComment?.totalAnswer > 0 && totalReply?.length === 0) ? (
                <div className='ml-[60px]'>
                    <button
                        onClick={onShowAllReplyComment}
                        style={{
                            color:
                                commentSetting?.version &&
                                commentSetting?.version === "2.0.0" &&
                                commentSetting.commentConfiguration.themeConfig
                                    .userBlock.textSeemoreReplyColor
                        }}
                        className='text-[#2D67AD] text-[14px] flex font-arial items-center font-weight-none sm:font-notosans-bold'>
                        {showLoading ? <LoadingIcon /> : <ReturnIcon />}
                        {/* <LoadingIcon /> */}
                        {/* <ReturnIcon /> */}
                        <span className='hover:underline my-auto cursor-pointer ml-[5px] '>
                            <Trans
                                i18nKey={"message.actions.seemoreReplyComment"}
                                values={{ counts: dataComment.totalAnswer }}
                            />
                        </span>
                    </button>
                </div>
            ) : null}
        </div>
    );
}

export default CommentBox;
